<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="名称">
              <a-input placeholder="请输入名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="一级分类">
              <j-dict-select-tag placeholder="请选择一级分类" v-model="queryParam.category" dictCode="brand_strength_one"   @input="selectDictOneChange" />
            </a-form-item>
          </a-col>
          <div v-show="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="二级分类">
                <j-dict-select-tag placeholder="请选择二级分类" v-model="queryParam.detailCategory" dictCode="brand_strength_two" ref="detailCategoryRef"   />
                <!-- <a-select   v-model="queryParam.detailCategory" >
                  <a-select-option v-for="(item, key) in dictTwoOptions" :key="key" :value="item.value">
                    <span style="display: inline-block;width: 100%" :title=" item.text || item.label ">
                      {{ item.text || item.label }}
                    </span>
                  </a-select-option>
                </a-select> -->
              </a-form-item>
            </a-col>
          </div>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('品牌实力表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <busGisBrandPower-modal ref="modalForm" @ok="modalFormOk"></busGisBrandPower-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BusGisBrandPowerModal from './modules/BusGisBrandPowerModal'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import {queryDetailCategoryListByCategory } from "@/api/api"

  export default {
    name: "BusGisBrandPowerList",
    mixins:[JeecgListMixin],
    components: {
      JDictSelectTag,
      BusGisBrandPowerModal
    },
    data () {
      return {
        description: '品牌实力表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'名称',
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'一级分类',
            align:"center",
            dataIndex: 'category_dictText'
          },
          {
            title:'二级分类',
            align:"center",
            dataIndex: 'detailCategory_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/base/busGisBrandPower/list",
          delete: "/base/busGisBrandPower/delete",
          deleteBatch: "/base/busGisBrandPower/deleteBatch",
          exportXlsUrl: "/base/busGisBrandPower/exportXls",
          importExcelUrl: "base/busGisBrandPower/importExcel",
        },
        dictTwoOptions:[],
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
      selectDictOneChange(val){
        console.log(this.queryParam)
        this.dictTwoOptions=[]
        this.$refs.detailCategoryRef.clearData();
        queryDetailCategoryListByCategory({
            category:val
        }).then(res=>{
          if(res.code==200){
            if(res.result.length>0){
              for (const key of res.result) {
                this.dictTwoOptions.push({
                  text:key.item_text,
                  value:key.item_value
                })
              }
              this.$refs.detailCategoryRef.setCurrentDictOptions(this.dictTwoOptions)
            }else{
              this.$message.success("暂无该分类下的数据")
            }
          }else{
            this.$message.error(res.message)
          }
        }).catch(err=>{
          this.$message.error(err)
        })
      },
      selectDictTwoChange(){

      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>